export const isRelease261Enabled = process.env.REACT_APP_SHOW_RELEASE_261 === 'true';
